import { ProfilesService } from "../../services/profiles/service";
import { KDProfileData } from "../../domain/kdiagram/profiles/data";
import { kdProfileDataFromJson } from "../../domain/kdiagram/profiles/mapper";
import { kdProfileCreateDataToJson, kdProfileDataToJson } from "../../domain/kdiagram/profiles/mapper_to_json";

const profilesService = new ProfilesService(
  localStorage.getItem("basicUrl"),
  kdProfileDataFromJson,
  kdProfileCreateDataToJson,
  kdProfileDataToJson
);

const getDefaultState = () => {
  return {
    profileData: KDProfileData.defaultData(),
    updateLoading: false,
    updateError: null,
    profileUpdateSuccess: null,
    profileUpdateFailed: null,
  };
};

const state = getDefaultState();

const getters = {
};

const actions = {
  updateProfile: async ({ commit }, profileData) => {
    commit("SET_UPDATE_LOADING_STATE");
    try {
      const updatedProfile = await profilesService.updateOne(
        localStorage.getItem("quad_token"),
        profileData.vesselName,
        profileData.profileData
      );
      commit("kDiagram/profiles/SET_UPDATE_PROFILE", updatedProfile, { root: true });
      commit("SET_UPDATE_SUCCESS_STATE");
    } catch (error) {
      commit("SET_UPDATE_FAILED_STATE", error);
    }
  },

};

const mutations = {
  SET_UPDATE_LOADING_STATE: (state) => {
    state.updateLoading = true;
    state.updateError = null;
    state.profileUpdateSuccess = false;
    state.profileUpdateFailed = false;
  },
  SET_UPDATE_FAILED_STATE: (state, error) => {
    state.updateLoading = false;
    state.updateError = error;
    state.profileUpdateSuccess = false;
    state.profileUpdateFailed = true;
  },
  SET_UPDATE_SUCCESS_STATE: (state) => {
    state.updateLoading = false;
    state.profileUpdateSuccess = true;
    state.profileUpdateFailed = false;
  },
  SET_PROFILE_DATA_ATTRIBUTE: (state, data) => {

    state.profileData[data.attribute] = data.value;
  },
  SET_UPDATE_PROFILE_SUCCESS: (state, value) => {
    state.profileUpdateSuccess = value;
  },
  SET_PROFILE_DATA: function SET_PROFILE_DATA(state, data) {
    state.profileData = {
      ...data,
      useLatestFouling: (data.useLatestFouling !== undefined && data.useLatestFouling !== null)
        ? data.useLatestFouling
        : (data.use_latest_fouling !== undefined && data.use_latest_fouling !== null)
          ? data.use_latest_fouling
          : false
    };
  },

  RESTORE_REQUEST_STATE: (state) => {
    state.profileUpdateSuccess = null;
    state.profileUpdateFailed = null;
  }
};

export const kdiagramEditProfileModule = {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
